import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

export type CurrentStateInfoType = {
  _id: string,
  cid: string,
  // お部屋情報
  rid: number,
  rname: string,
  bedNo: string,
  // 最新時間
  time: number,
  // 利用者情報
  careReceiver: {
    "id": number,
    "code": string, // MongoDBの利用者ID,
    "name": string,
    "nameKana": string,
    "icon": string | null,
    "mail": string | null,
    "gender": string | null,
    "birthday": string | null,
    "uniqId": string | null,
    "createdAt": string, // "2023-04-11T17:42:04.000Z",
    "updatedAt": string, // "2023-04-12T05:26:05.000Z",
    "deletedAt": string | null, // null
  } | null,
  // センサー情報
  state: { "v": number, "time": number, "_id": string } | null,
  vbt: { "v": number, "time": number, "_id": string } | null,
  vbph: { "v": number, "time": number, "_id": string } | null,
  vbpl: { "v": number, "time": number, "_id": string } | null,
  vhb: { "v": number, "time": number, "_id": string } | null,
  vrr: { "v": number, "time": number, "_id": string } | null,

  el: { "v": number, "time": number, "_id": string } | null,
  ep: { "v": number, "time": number, "_id": string } | null,
  es: { "v": number, "time": number, "_id": string } | null,
  et: { "v": number, "time": number, "_id": string } | null,
  eh: { "v": number, "time": number, "_id": string } | null,
  sh: { "v": number, "time": number, "_id": string } | null,
  sd: { "v": number, "time": number, "_id": string } | null,
  // アラート情報
  alert: {
    "_id": string,
    "code": string,
    "title": string, // "離床",
    "subtitle": string,
    "time": number,
    "status": number,
    "level": string, //"danger",
  } | null,
  createdAt: number,
  updatedAt: number,
  "__v": number,

};
@Injectable()
export class ApiCurrentCareRecordsServce extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = false;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  async getCurrentInfo(viewerId: number): Promise<{
    "status": number,
    "message": string,
    "data": CurrentStateInfoType[],
  }> {
    const apiUrl = `https://app-api-v2.cdc-iot.com`;
    return this.doGetViewerApi({
      url:`${apiUrl}/api/v2/viewers/${viewerId}/state`,
      body: {}, headers: {
        'Content-type': 'application/json'
      }}
    ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-current-care-records.service.ts